import React, { useState, useEffect } from 'react';
import img1 from './assets/images/2025-04-21.webp';
import img2 from './assets/images/20251210_065436.jpg';
import img3 from './assets/images/20251210_070711.jpg';
import img4 from './assets/images/20251210_071948.jpg';
import img5 from './assets/images/20251210_153526.jpg';
import img6 from './assets/images/20251212_193510.jpg';
import img7 from './assets/images/20251213_185216.jpg';
import img8 from './assets/images/20251217_125351.jpg';
import img9 from './assets/images/20251217_171557.jpg';
import img10 from './assets/images/20251219_211210.jpg';
import img11 from './assets/images/20251220_211632.jpg';
import img12 from './assets/images/20251221_184147.jpg';
import img13 from './assets/images/20251225_023803.jpg';
import img14 from './assets/images/20251228_220848.jpg';
import img15 from './assets/images/20260102_213227.jpg';
import img16 from './assets/images/20260102_213539 2.jpg';
import img17 from './assets/images/20260102_213539.jpg';
import img18 from './assets/images/20260104_182639.jpg';
import img19 from './assets/images/20260109_182443.jpg';
import img20 from './assets/images/20260109_182504.jpg';
import img21 from './assets/images/20260114_141639.jpg';
import img22 from './assets/images/20260114_142057.jpg';
import img23 from './assets/images/20260114_142127.jpg';
import img24 from './assets/images/20260118_214623.jpg';
import img25 from './assets/images/20260121_145810.jpg';
import img26 from './assets/images/20260122_182846.jpg';
import img27 from './assets/images/unnamed (1).webp';
import img28 from './assets/images/unnamed (2).webp';
import img29 from './assets/images/unnamed (3).webp';
import img30 from './assets/images/unnamed (4).webp';
import img31 from './assets/images/unnamed.jpg';
import img32 from './assets/images/unnamed.webp';
import casaImage from './assets/images/20260102_213539.jpg';
import villaImage from './assets/images/unnamed (1).webp';
import { ChevronDown, Phone, Instagram, MapPin, Wifi, Coffee, Waves, Mountain, Users, Star, Menu, X, Calendar, Check, Sparkles, Sun, Moon, ChevronLeft, ChevronRight, Camera } from 'lucide-react';

const RockBottomVillas = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [selectedVilla, setSelectedVilla] = useState("");
  const [bookingData, setBookingData] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
    checkInDate: '',
    checkOutDate: '',
    adults: '1',
    children: '0',
    guestType: 'Family'
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };

  const features = [
  { icon: Waves, title: "Private Pool", desc: "Luxury private pools in every villa", color: "from-cyan-400 to-blue-500" },
  { icon: Mountain, title: "Serene Garden View", desc: "Relax in lush, peaceful garden surroundings", color: "from-emerald-400 to-teal-500" },
  { icon: MapPin, title: "Free Parking", desc: "Spacious parking for cars and two-wheelers", color: "from-yellow-400 to-green-400" },
  { icon: Star, title: "24/7 Security", desc: "Round-the-clock security for your peace of mind", color: "from-red-400 to-slate-700" },
  { icon: MapPin, title: "Near North Cliff", desc: "Just few minutes away from the famous North Cliff", color: "from-slate-700 to-cyan-400" },
  { icon: Wifi, title: "Free WiFi", desc: "High-speed internet throughout", color: "from-purple-400 to-indigo-500" },
  { icon: Coffee, title: "Breakfast", desc: "Complimentary breakfast included", color: "from-orange-400 to-red-500" },
  ];

  const villas = [
    
    {
      name: "CASA SOL",
      subTitle: "Single A-Frame",
      guests: 4,
  image: casaImage,
      gradient: "from-rose-400 via-pink-400 to-purple-500",
      description: [
        "Pool view",
        "2 Air Conditioner rooms",
        "1 Big Washrooms",
        "Swimming pool",
        "24/7 Security",
        "4 people accommodation",
        "Garden area",
        "Free Wifi",
        "Water Heater",
        "Free Parking Area (Car / Two Wheeler)",
        "Complementary",
        "Breakfast",
        "Drinking Water",
        "Room Service",
        "Power Backup",
        "Mini Bar (No Alcoholic Drinks)"
      ]
    },
    {
      name: "CASA LUNA",
            subTitle: "Single A-Frame",
      guests: 4,
  image: casaImage,
      gradient: "from-blue-400 via-cyan-400 to-teal-500",
      description: [
        "Pool view",
        "2 Air Conditioner rooms",
        "1 Big Washrooms",
        "Swimming pool",
        "24/7 Security",
        "4 people accommodation",
        "Garden area",
        "Free Wifi",
        "Water Heater",
        "Free Parking Area (Car / Two Wheeler)",
        "Complementary",
        "Breakfast",
        "Drinking Water",
        "Room Service",
        "Power Backup",
        "Mini Bar (No Alcoholic Drinks)"
      ]
    },
    {
      name: "CASA ESTRELLA",
      subTitle: "Single A-Frame",
      guests: 4,
      image: casaImage,
      gradient: "from-amber-400 via-orange-400 to-red-500",
      description: [
        "Pool view",
        "2 Air Conditioner rooms",
        "1 Big Washrooms",
        "Swimming pool",
        "24/7 Security",
        "4 people accommodation",
        "Garden area",
        "Free Wifi",
        "Water Heater",
        "Free Parking Area (Car / Two Wheeler)",
        "Complementary",
        "Breakfast",
        "Drinking Water",
        "Room Service",
        "Power Backup",
        "Mini Bar (No Alcoholic Drinks)"
      ]
    },
    {
      name: "CORAL",
      guests: 4,
  image: villaImage,
      gradient: "from-cyan-400 via-blue-400 to-purple-500",
      description: [
        "2BHK entire villa",
        "Air Conditioner rooms",
        "Washing machine",
        "Fridge",
        "Kitchen",
        "Dining table",
        "2 Washrooms",
        "Swimming pool",
        "24/7 Security",
        "4 people accommodation (Extra bed will be provided)",
        "Garden area",
        "Free Wifi",
        "Water Heater",
        "Free Parking Area (Car / Two Wheeler)",
        "Drinking Water",
        "Room Service",
        "Power Backup"
      ]
    },
    {
      name: "PEARL",
      guests: 4,
  image: villaImage,
      gradient: "from-teal-400 via-green-400 to-blue-500",
      description: [
        "2BHK entire villa",
        "Air Conditioner rooms",
        "Washing machine",
        "Fridge",
        "Kitchen",
        "Dining table",
        "2 Washrooms",
        "Swimming pool",
        "24/7 Security",
        "4 people accommodation (Extra bed will be provided)",
        "Garden area",
        "Free Wifi",
        "Water Heater",
        "Free Parking Area (Car / Two Wheeler)",
        "Drinking Water",
        "Room Service",
        "Power Backup"
      ]
    },
    {
      name: "SAPPHIRE",
      guests: 6,
  image: villaImage,
      gradient: "from-blue-400 via-indigo-400 to-purple-500",
      description: [
        "3BHK entire villa",
        "Air Conditioner rooms",
        "Washing machine",
        "Fridge",
        "Kitchen",
        "Dining table",
        "3 Washrooms",
        "Swimming pool",
        "24/7 Security",
        "6 people accommodation (Extra bed will be provided)",
        "Garden area",
        "Free Wifi",
        "Water Heater",
        "Free Parking Area (Car / Two Wheeler)",
        "Drinking Water",
        "Room Service",
        "Power Backup"
      ]
    },
  ];

  const amenities = Array.from(new Set([
    // CASA SOL
    "Pool view",
    "Air Conditioner rooms",
    "Swimming pool",
    "24/7 Security",
    "Garden area",
    "Free Wifi",
    "Water Heater",
    "Free Parking Area (Car / Two Wheeler)",
    "Complementary Breakfast",
    "Drinking Water",
    "Room Service",
    "Power Backup",
    "Mini Bar (No Alcoholic Drinks)",
    // CORAL
    "Air Conditioner rooms",
    "Washing machine",
    "Fridge",
    "Kitchen",
    "Dining table",
    "Swimming pool",
    "24/7 Security",
    "Garden area",
    "Free Wifi",
    "Water Heater",
    "Free Parking Area (Car / Two Wheeler)",
    "Drinking Water",
    "Room Service",
    "Power Backup",
    
  ]));

  const galleryImages = [
    { id: 1, title: "Front View", category: "Exterior", image: img1 },
    { id: 2, title: "Morning View", category: "Exterior", image: img2 },
    { id: 3, title: "Sunrise Pool", category: "Pool", image: img3 },
    { id: 5, title: "Evening Lights", category: "Exterior", image: img5 },
    { id: 6, title: "Night Ambience", category: "Exterior", image: img6 },
    { id: 8, title: "Lawn Area", category: "Garden", image: img8 },
    { id: 9, title: "Outdoor Seating", category: "Garden", image: img9 },
    { id: 11, title: "Villa Night", category: "Interior", image: img11 },
    { id: 12, title: "Dining Area", category: "Interior", image: img12 },
    { id: 13, title: "Bedroom", category: "Interior", image: img13 },
    { id: 14, title: "Living Room", category: "Interior", image: img14 },
    { id: 15, title: "Balcony", category: "Exterior", image: img15 },
    { id: 16, title: "Poolside Night", category: "Pool", image: img16 },
    { id: 18, title: "Garden View", category: "Interior", image: img18 },
    { id: 19, title: "Bedroom 2", category: "Interior", image: img19 },
    { id: 21, title: "Bathroom", category: "Interior", image: img21 },
    { id: 22, title: "Kitchen", category: "Interior", image: img22 },
    { id: 23, title: "Dining Table", category: "Interior", image: img23 },
    { id: 24, title: "Garden Night", category: "Garden", image: img24 },
    { id: 25, title: "Villa Entrance", category: "Exterior", image: img25 },
    { id: 26, title: "Garden Lights", category: "Garden", image: img26 },
    { id: 27, title: "Front View", category: "Exterior", image: img27 },
    { id: 28, title: "Room", category: "Interior", image: img28 },
    { id: 29, title: "Garden Flowers", category: "Interior", image: img29 },
    { id: 30, title: "Garden Bench", category: "Garden", image: img30 },
    // { id: 31, title: "Villa Sign", category: "Exterior", image: img31 },
    { id: 32, title: "Villa Overview", category: "Exterior", image: img32 },
  ];

  const categories = ["All", "Exterior", "Pool", "Interior", "Garden"];
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredImages = activeCategory === "All" 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setSelectedImage(galleryImages[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentImageIndex + 1) % galleryImages.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const prevImage = () => {
    const newIndex = (currentImageIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentImageIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const handleBookingInputChange = (e) => {
    const { name, value } = e.target;
    setBookingData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    
    // Validate all fields
    if (!bookingData.fullName || !bookingData.email || !bookingData.contactNumber || 
        !bookingData.checkInDate || !bookingData.checkOutDate) {
      alert('Please fill in all required fields');
      return;
    }

  // Create WhatsApp message
  const message = `*New Booking Request - Rock Bottom Pool Villa*

*Villa:* ${selectedVilla}

*Guest Details:*
Name: ${bookingData.fullName}
Email: ${bookingData.email}
Contact: ${bookingData.contactNumber}

*Booking Details:*
Check-in: ${bookingData.checkInDate}
Check-out: ${bookingData.checkOutDate}
Adults: ${bookingData.adults}
Children: ${bookingData.children}
Guest Type: ${bookingData.guestType}`;

    // Encode message for WhatsApp URL
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/919746498989?text=${encodedMessage}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappURL, '_blank');
    
    // Reset form and close popup
    setBookingData({
      fullName: '',
      email: '',
      contactNumber: '',
      checkInDate: '',
      checkOutDate: '',
      adults: '1',
      children: '0',
      guestType: 'Family'
    });
    setShowBookingForm(false);
  };

  const handleBookNowClick = (villaName) => {
    setSelectedVilla(villaName);
    setShowBookingForm(true);
  };

  return (
    <div className="bg-gradient-to-b from-slate-50 via-white to-slate-50 font-sans">
      {/* Navigation */}
      <nav className={`fixed w-full z-40 transition-all duration-500 ${scrolled ? 'bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-2xl shadow-purple-500/20' : 'bg-slate-900/95 backdrop-blur-md'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-3 animate-fadeIn cursor-pointer" onClick={() => scrollToSection('home')}>
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl blur-lg opacity-75 animate-pulse"></div>
                <Mountain className="relative w-10 h-10 text-white animate-bounce" style={{animationDuration: '3s'}} />
              </div>
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-rose-400 bg-clip-text text-transparent tracking-wider">Rock Bottom</h1>
                <p className="text-cyan-400 text-xs font-semibold tracking-widest">POOL VILLA</p>
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              {['Home', 'Villas', 'Gallery', 'Amenities', 'Contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase())}
                  className="text-white hover:text-transparent hover:bg-gradient-to-r hover:from-purple-400 hover:to-pink-400 hover:bg-clip-text transition-all duration-300 font-medium relative group"
                >
                  {item}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 group-hover:w-full transition-all duration-300"></span>
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-slate-900 border-t border-purple-500/30 animate-slideDown">
            {['Home', 'Villas', 'Gallery', 'Amenities', 'Contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="block w-full text-left px-4 py-3 text-white hover:bg-slate-800 hover:text-purple-400 transition-all"
              >
                {item}
              </button>
            ))}
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900"></div>
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-72 h-72 bg-purple-500 rounded-full blur-3xl opacity-30 animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-pink-500 rounded-full blur-3xl opacity-30 animate-pulse" style={{animationDelay: '1s'}}></div>
          <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-cyan-500 rounded-full blur-3xl opacity-20 animate-pulse" style={{animationDelay: '2s'}}></div>
        </div>
        
        <div className="relative z-10 text-center px-4 max-w-5xl animate-fadeIn">
          <div className="mb-8 inline-block">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <div className="h-px w-16 bg-gradient-to-r from-transparent via-purple-400 to-transparent"></div>
              <Sparkles className="w-6 h-6 text-cyan-400 animate-spin" style={{animationDuration: '4s'}} />
              <div className="h-px w-16 bg-gradient-to-r from-transparent via-pink-400 to-transparent"></div>
            </div>
            <h1 className="text-6xl md:text-8xl font-bold text-white mb-4 tracking-tight">
              Rock Bottom
              <span className="block bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent mt-2">Pool Villa</span>
            </h1>
          </div>
          
          <p className="text-xl md:text-2xl text-slate-300 mb-12 font-light">
            Experience luxury amidst nature's paradise
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button 
              onClick={handleBookNowClick}
              className="group px-10 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full font-bold text-lg hover:from-purple-600 hover:to-pink-600 transform hover:scale-105 transition-all duration-300 shadow-2xl shadow-purple-500/50 hover:shadow-pink-500/50 flex items-center gap-2"
            >
              Book Your Stay
              <Calendar className="w-5 h-5 group-hover:rotate-12 transition-transform" />
            </button>
            <a 
              href="tel:+919746498989"
              className="px-10 py-4 border-2 border-cyan-400 text-cyan-400 rounded-full font-bold text-lg hover:bg-cyan-400 hover:text-slate-900 transform hover:scale-105 transition-all duration-300 flex items-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Call Now
            </a>
          </div>
        </div>

        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-cyan-400" />
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-500 via-pink-500 to-cyan-500"></div>
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, idx) => (
              <div 
                key={idx}
                className="group text-center p-8 rounded-2xl bg-white hover:shadow-2xl hover:shadow-purple-500/20 transition-all duration-500 transform hover:-translate-y-3 border border-slate-200 hover:border-purple-300"
                style={{animationDelay: `${idx * 0.1}s`}}
              >
                <div className={`w-20 h-20 mx-auto mb-6 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-500 shadow-lg`}>
                  <feature.icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">{feature.title}</h3>
                <p className="text-slate-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Villas Section */}
      <section id="villas" className="py-24 bg-gradient-to-b from-slate-50 to-white relative">
        <div className="absolute inset-0 overflow-hidden opacity-10">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-300 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 relative">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-cyan-600 bg-clip-text text-transparent mb-4">Our Villas</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto mb-6"></div>
            <p className="text-xl text-slate-600">Choose your perfect retreat</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {villas.map((villa, idx) => (
              <div 
                key={idx}
                className="group bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-purple-500/30 transition-all duration-500 transform hover:-translate-y-3 border border-slate-200"
              >
                <div className={`h-64 bg-gradient-to-br ${villa.gradient} flex items-center justify-center text-8xl relative overflow-hidden`}>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
                  {<img src={villa.image} alt={villa.name} className="absolute inset-0 w-full h-full object-cover z-10" />}
                  <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-md px-4 py-2 rounded-full text-white text-sm font-bold">
                    Popular
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-slate-800">{villa.name}</h3>
                  <h6 className="text-l text-slate-600 mb-4">{villa.subTitle}</h6>
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center text-slate-600">
                      <Users className="w-5 h-5 mr-2 text-purple-500" />
                      <span>Up to {villa.guests} guests</span>
                    </div>
                  </div>
                  <ul className="mb-6 text-slate-700 list-disc pl-5 space-y-1">
                    {villa.description.map((desc, i) => (
                      <li key={i}>{desc}</li>
                    ))}
                  </ul>
                  <button 
                    onClick={() => handleBookNowClick(villa.name)}
                    className="w-full py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold hover:from-purple-600 hover:to-pink-600 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
                  >
                    Book Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Amenities Section */}
      <section id="amenities" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-cyan-600 bg-clip-text text-transparent mb-4">Amenities</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto mb-6"></div>
            <p className="text-xl text-slate-600">Everything you need for a perfect stay</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {amenities.map((amenity, idx) => (
              <div 
                key={idx}
                className="flex items-center space-x-3 p-4 bg-gradient-to-br from-slate-50 to-white rounded-xl hover:shadow-lg hover:shadow-purple-500/20 transition-all duration-300 group border border-slate-200"
              >
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center flex-shrink-0">
                  <Check className="w-5 h-5 text-white" />
                </div>
                <span className="text-slate-700 font-medium">{amenity}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-24 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/3 left-1/3 w-96 h-96 bg-cyan-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/3 right-1/3 w-96 h-96 bg-purple-300 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 relative">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-cyan-600 bg-clip-text text-transparent mb-4">Gallery</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto mb-6"></div>
            <p className="text-xl text-slate-600">Explore our beautiful villas</p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 ${
                  activeCategory === category
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg shadow-purple-500/50'
                    : 'bg-white text-slate-700 border-2 border-slate-200 hover:border-purple-300'
                }`}
              >
                {category}
                {category !== "All" && (
                  <span className="ml-2 text-xs opacity-75">
                    ({galleryImages.filter(img => img.category === category).length})
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image, idx) => (
              <div
                key={image.id}
                onClick={() => openLightbox(galleryImages.indexOf(image))}
                className="group relative h-80 rounded-2xl overflow-hidden cursor-pointer transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-2xl animate-fadeIn"
                style={{animationDelay: `${idx * 0.1}s`}}
              >
                <div className="absolute inset-0 w-full h-full flex items-center justify-center bg-slate-200">
                  {image.image ? (
                    <img src={image.image} alt={image.title} className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-9xl group-hover:scale-110 transition-transform duration-500">{image.emoji}</span>
                  )}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  {/* <div className="inline-block px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-xs mb-2">
                    {image.category}
                  </div> */}
                  {/* <h3 className="text-xl font-bold">{image.title}</h3> */}
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <Camera className="w-5 h-5 text-white" />
                </div>
              </div>
            ))}
          </div>

          {/* No Results Message */}
          {filteredImages.length === 0 && (
            <div className="text-center py-20">
              <p className="text-slate-500 text-lg">No images found in this category</p>
            </div>
          )}
        </div>
      </section>

      {/* Booking Form Modal */}
      {showBookingForm && (
        <div 
          className="fixed inset-0 bg-black/90 z-[100] flex items-start justify-center p-4 animate-fadeIn overflow-y-auto pt-8 pb-8"
          onClick={() => setShowBookingForm(false)}
        >
          <div 
            className="bg-white rounded-3xl max-w-2xl w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-cyan-500 p-6">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-3xl font-bold text-white mb-2">Book Your Stay</h2>
                  <p className="text-white/90">Fill in your details to reserve your villa</p>
                </div>
                <button
                  onClick={() => setShowBookingForm(false)}
                  className="w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            <form onSubmit={handleBookingSubmit} className="p-8">
              <div className="space-y-6">
                {/* Full Name */}
                <div>
                  <label className="block text-slate-700 font-semibold mb-2">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    value={bookingData.fullName}
                    onChange={handleBookingInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    placeholder="Enter your full name"
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block text-slate-700 font-semibold mb-2">
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={bookingData.email}
                    onChange={handleBookingInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    placeholder="your.email@example.com"
                  />
                </div>

                {/* Contact Number */}
                <div>
                  <label className="block text-slate-700 font-semibold mb-2">
                    Contact Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="contactNumber"
                    value={bookingData.contactNumber}
                    onChange={handleBookingInputChange}
                    required
                    pattern="[0-9]{10}"
                    className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    placeholder="10-digit mobile number"
                  />
                </div>

                {/* Check-in and Check-out Dates */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-slate-700 font-semibold mb-2">
                      Check-In Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="checkInDate"
                      value={bookingData.checkInDate}
                      onChange={handleBookingInputChange}
                      required
                      min={new Date().toISOString().split('T')[0]}
                      className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-slate-700 font-semibold mb-2">
                      Check-Out Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="checkOutDate"
                      value={bookingData.checkOutDate}
                      onChange={handleBookingInputChange}
                      required
                      min={bookingData.checkInDate || new Date().toISOString().split('T')[0]}
                      className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    />
                  </div>
                </div>

                {/* Number of Guests */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-slate-700 font-semibold mb-2">
                      Number of Adults
                    </label>
                    <select
                      name="adults"
                      value={bookingData.adults}
                      onChange={handleBookingInputChange}
                      className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-slate-700 font-semibold mb-2">
                      Number of Children
                    </label>
                    <select
                      name="children"
                      value={bookingData.children}
                      onChange={handleBookingInputChange}
                      className="w-full px-4 py-3 border-2 border-slate-200 rounded-xl focus:border-purple-500 focus:outline-none transition-all"
                    >
                      {[0, 1, 2, 3, 4, 5, 6].map(num => (
                        <option key={num} value={num}>{num}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Guest Type */}
                <div>
                  <label className="block text-slate-700 font-semibold mb-3">
                    Guest Type <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-6">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="guestType"
                        value="Family"
                        checked={bookingData.guestType === 'Family'}
                        onChange={handleBookingInputChange}
                        className="w-5 h-5 text-purple-500 focus:ring-purple-500"
                      />
                      <span className="ml-3 text-slate-700 font-medium">Family</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="guestType"
                        value="Couple"
                        checked={bookingData.guestType === 'Couple'}
                        onChange={handleBookingInputChange}
                        className="w-5 h-5 text-purple-500 focus:ring-purple-500"
                      />
                      <span className="ml-3 text-slate-700 font-medium">Couple</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="guestType"
                        value="Others"
                        checked={bookingData.guestType === 'Others'}
                        onChange={handleBookingInputChange}
                        className="w-5 h-5 text-purple-500 focus:ring-purple-500"
                      />
                      <span className="ml-3 text-slate-700 font-medium">Others</span>
                    </label>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl font-bold text-lg hover:from-purple-600 hover:to-pink-600 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                >
                  <Phone className="w-5 h-5" />
                  Send Booking Request via WhatsApp
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all z-10"
          >
            <X className="w-6 h-6" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all z-10"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all z-10"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          <div 
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`w-full h-[70vh] rounded-3xl bg-gradient-to-br ${selectedImage.gradient} flex items-center justify-center shadow-2xl`}>
              {selectedImage.image ? (
                <img src={selectedImage.image} alt={selectedImage.title} className="absolute inset-0 w-full h-full object-cover rounded-3xl" />
              ) : (
                <span className="text-[20rem] animate-pulse">{selectedImage.emoji}</span>
              )}
            </div>
            <div className="mt-6 text-center">
              {/* <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-md rounded-full text-white text-sm mb-2">
                {selectedImage.category}
              </div> */}
              {/* <h3 className="text-3xl font-bold text-white mb-2">{selectedImage.title}</h3> */}
              <p className="text-slate-300">Image {currentImageIndex + 1} of {galleryImages.length}</p>
            </div>
          </div>
        </div>
      )}

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500 rounded-full blur-3xl opacity-20"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-500 rounded-full blur-3xl opacity-20"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 relative">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold mb-4">Get In Touch</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-400 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
            <a 
              href="tel:+919746498989"
              className="group block hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg shadow-purple-500/50 group-hover:shadow-purple-500/80">
                <Phone className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-purple-300 transition-colors">Call Us</h3>
              <p className="text-slate-300 group-hover:text-white transition-colors">+91 97464 98989</p>
              <p className="text-slate-300 group-hover:text-white transition-colors">+91 77364 81586</p>
            </a>

            <a 
              href="https://www.instagram.com/rockbottomvarkala/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="group block hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-pink-500 to-cyan-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg shadow-pink-500/50 group-hover:shadow-pink-500/80">
                <Instagram className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-pink-300 transition-colors">Follow Us</h3>
              <p className="text-slate-300 group-hover:text-white transition-colors">@rockbottomvarkala</p>
            </a>

            <a 
              href="https://www.google.com/maps/search/?api=1&query=Rock+Bottom+Pool+Villas+Attingal+Kerala"
              target="_blank"
              rel="noopener noreferrer"
              className="group block hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-cyan-500 to-purple-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg shadow-cyan-500/50 group-hover:shadow-cyan-500/80">
                <MapPin className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-2 group-hover:text-cyan-300 transition-colors">Visit Us</h3>
              <p className="text-slate-300 group-hover:text-white transition-colors">Varkala, Kerala</p>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-12 text-center">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Mountain className="w-8 h-8 text-purple-400" />
            <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Rock Bottom Pool Villa</span>
          </div>
          <p className="mb-4">Experience luxury. Embrace nature.</p>
          <p className="text-sm">© 2026 Rock Bottom Pool Villa. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default RockBottomVillas;